// Shared formatters for CBR public game statistics.
// Golden rule: never render a false 0 for a rate — use "—" when the value is null.

export const EMDASH = "—";

// Baseball rate: .423, 1.247, etc. (strip leading zero for values below 1)
export const rate3 = (v) => {
  if (v == null || Number.isNaN(v)) return EMDASH;
  const s = Number(v).toFixed(3);
  return Math.abs(v) < 1 ? s.replace(/^(-?)0/, "$1") : s;
};

// ERA / WHIP / K9 etc. (2 decimals, keep leading digit)
export const rate2 = (v) => (v == null || Number.isNaN(v) ? EMDASH : Number(v).toFixed(2));
export const rate1 = (v) => (v == null || Number.isNaN(v) ? EMDASH : Number(v).toFixed(1));

// Percent rate stored as fraction (0.182 -> 18.2%)
export const pct = (v) => (v == null || Number.isNaN(v) ? EMDASH : `${(Number(v) * 100).toFixed(1)}%`);

// Counting stat — 0 is a real value here, so show it.
export const cnt = (v) => (v == null ? 0 : v);

export const velo = (v) => (v == null ? EMDASH : `${Number(v).toFixed(1)}`);

// def_outs -> defensive innings notation "7.0", "7.1"
export const inningsFromOuts = (outs) => {
  const o = Number(outs || 0);
  return `${Math.floor(o / 3)}.${o % 3}`;
};

export const fmtDate = (d) => {
  if (!d) return EMDASH;
  try {
    return new Date(d + (d.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-CA", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch {
    return d;
  }
};

// Compact hitting summary line: "3-for-4, 2B, 2 RBI, BB"
export const hittingLine = (h) => {
  if (!h) return null;
  const parts = [];
  const ab = cnt(h.ab), hh = cnt(h.h);
  if (ab > 0 || hh > 0) parts.push(`${hh}-for-${ab}`);
  if (cnt(h.doubles)) parts.push(`${h.doubles} 2B`);
  if (cnt(h.triples)) parts.push(`${h.triples} 3B`);
  if (cnt(h.hr)) parts.push(`${h.hr} HR`);
  if (cnt(h.rbi)) parts.push(`${h.rbi} RBI`);
  if (cnt(h.bb)) parts.push(`${h.bb} BB`);
  if (cnt(h.sb)) parts.push(`${h.sb} SB`);
  if (cnt(h.so)) parts.push(`${h.so} K`);
  return parts.length ? parts.join(", ") : null;
};

// Compact pitching summary line: "6.0 IP, 8 SO, 1 ER"
export const pitchingLine = (p) => {
  if (!p || cnt(p.ip_outs) === 0) return null;
  const parts = [`${p.ip || inningsFromOuts(p.ip_outs)} IP`];
  if (cnt(p.h)) parts.push(`${p.h} H`);
  if (cnt(p.so)) parts.push(`${p.so} SO`);
  if (cnt(p.bb)) parts.push(`${p.bb} BB`);
  parts.push(`${cnt(p.er)} ER`);
  return parts.join(", ");
};
